import { useState } from "react";
import { motion } from "framer-motion";

export function Example() {
  const [degrees, setDegrees] = useState(0);

  return (
    <motion.div
      style={{
        width: 150,
        height: 150,
        borderRadius: 30,
        backgroundColor: "#fff",
        color: "#999",
        fontSize: "40px",
        display: "flex",
        placeItems: "center",
        placeContent: "center",
        cursor: "ew-resize"
      }}
      animate={{ rotate: degrees }}
      onPan={(_, info) => setDegrees(degrees + info.delta.x)}
    >
      {Math.round(degrees)}
    </motion.div>
  );
}
